module.exports = __webpack_public_path__ + "media/night/395-b1198935.svg";